/**
 * Puzzle Makeup - Rebuy Tiered Progress Bar + Bundle Label Helpers
 *
 * Goals:
 * - Progress bar tiers based on qualifying item count (3, 6, 9)
 * - Free shipping message based on subtotal ($50)
 * - Exclude gift items
 * - Exclude products selected in Rebuy "Search Products to Exclude" (if exposed on progressBar object)
 * - Exclude items under $15 from qualifying count
 * - Provide bundle label helpers for line items (3+ Item Bundle, 6+ Item Bundle, 9+ Item Bundle)
 *
 * Rebuy tier configuration:
 * - Set tier minimums (unlock values) to 3, 6, 9 for 10%, 15%, 20%
 * - Do not add a separate "Free Shipping" tier to this same bar
 */

(function () {
  // Config
  var MIN_UNIT_PRICE_CENTS = 1500; // $15.00
  var FREE_SHIP_THRESHOLD_CENTS = 5000; // $50.00

  // Debug toggle
  var DEBUG = false;
  function log() {
    if (!DEBUG) return;
    try { console.log.apply(console, arguments); } catch (e) {}
  }

  // Resolve cart if not passed in
  function resolveCart(cart) {
    if (cart) return cart;

    try {
      if (window.Rebuy && Rebuy.SmartCart && Rebuy.SmartCart.cart) return Rebuy.SmartCart.cart;
    } catch (e) {}

    try {
      if (window.Rebuy && Rebuy.Cart && Rebuy.Cart.cart) return Rebuy.Cart.cart;
    } catch (e) {}

    return { items: [] };
  }

  // Items can live under different keys depending on payload
  function safeItems(cart) {
    var c = resolveCart(cart);
    if (!c) return [];

    if (Array.isArray(c.items)) return c.items;
    if (Array.isArray(c.line_items)) return c.line_items;
    if (Array.isArray(c.lineItems)) return c.lineItems;
    if (Array.isArray(c.cart_items)) return c.cart_items;
    if (Array.isArray(c.cartItems)) return c.cartItems;

    if (c.cart && Array.isArray(c.cart.items)) return c.cart.items;
    if (c.cart && Array.isArray(c.cart.line_items)) return c.cart.line_items;
    if (c.cart && Array.isArray(c.cart.lineItems)) return c.cart.lineItems;

    return [];
  }

  function isGiftItem(item) {
    try {
      return !!(
        window.Rebuy &&
        Rebuy.SmartCart &&
        typeof Rebuy.SmartCart.isGiftItem === "function" &&
        Rebuy.SmartCart.isGiftItem(item)
      );
    } catch (e) {
      return false;
    }
  }

  // Honor Rebuy "Search Products to Exclude" if it is exposed on progressBar
  function isExcludedByProgressBar(item, progressBar) {
    try {
      var productId = Number(item && (item.product_id || item.productId));
      if (!productId) return false;

      var excluded = progressBar && (progressBar.excluded_products || progressBar.excludedProducts);
      if (!excluded) return false;

      if (Array.isArray(excluded)) {
        for (var i = 0; i < excluded.length; i++) {
          var ex = excluded[i];
          var exId = Number(ex && (ex.id || ex.product_id || ex));
          if (exId && exId === productId) return true;
        }
      }
    } catch (e) {}
    return false;
  }

  // Money is typically in cents on cart item objects
  function getUnitPriceCents(item) {
    if (!item) return 0;

    var candidates = [
      item.final_price,
      item.discounted_price,
      item.price,
      item.original_price,
      item.variant_price
    ];

    for (var i = 0; i < candidates.length; i++) {
      var v = Number(candidates[i]);
      if (!isNaN(v) && v > 0) return v;
    }

    // Fallback: derive from line price
    var qty = Number(item.quantity) || 0;
    var line = Number(item.final_line_price || item.line_price || item.finalLinePrice);
    if (qty > 0 && !isNaN(line) && line > 0) return Math.round(line / qty);

    return 0;
  }

  function cartSubtotalCents(cart) {
    var c = resolveCart(cart);

    var v = Number(c && (c.total_price || c.totalPrice));
    if (!isNaN(v) && v >= 0) return v;

    var items = safeItems(c);
    var sum = 0;

    for (var i = 0; i < items.length; i++) {
      var it = items[i];
      var line = Number(it && (it.final_line_price || it.line_price || it.finalLinePrice));
      if (!isNaN(line) && line > 0) sum += line;
      else sum += getUnitPriceCents(it) * Number(it.quantity || 0);
    }

    return sum;
  }

  function qualifyingItemCount(cart, progressBar) {
    var c = resolveCart(cart);
    var items = safeItems(c);

    log("PM DEBUG cart keys:", Object.keys(c || {}), "itemsLen:", items.length);

    var count = 0;

    for (var i = 0; i < items.length; i++) {
      var item = items[i];

      if (isGiftItem(item)) continue;
      if (isExcludedByProgressBar(item, progressBar)) continue;

      var unitPrice = getUnitPriceCents(item);
      if (unitPrice < MIN_UNIT_PRICE_CENTS) continue;

      count += Number(item.quantity || 0);
    }

    return count;
  }

  function sortedTiers(bar) {
    var tiers = bar && Array.isArray(bar.tiers) ? bar.tiers.slice() : [];
    tiers.sort(function (a, b) {
      return Number(a.minimum || 0) - Number(b.minimum || 0);
    });
    return tiers;
  }

  function clamp(n, min, max) {
    return Math.max(min, Math.min(max, n));
  }

  function toPct(n) {
    return clamp(Math.round(n), 0, 100);
  }

  // Public: qualifying count so you can use it in any Smart Cart template (line items, cart header, etc)
  window.pmQualifyingItemCount = function (cart, progressBar) {
    return qualifyingItemCount(cart, progressBar);
  };

  // Public: label for the highest unlocked bundle tier
  window.pmBundleLabel = function (qualifyingCount) {
    var q = Number(qualifyingCount || 0);
    if (q >= 9) return "9+ Item Bundle";
    if (q >= 6) return "6+ Item Bundle";
    if (q >= 3) return "3+ Item Bundle";
    return "";
  };

  // Public: label for a specific tier minimum
  window.pmTierRewardCopy = function (min) {
    min = Number(min || 0);
    if (min === 3) return "10% off (3+ items)";
    if (min === 6) return "15% off (6+ items)";
    if (min === 9) return "20% off (9+ items)";
    return min + "+ items";
  };

  // Tier reached by qualifying items
  window.pmTierReachedByItems = function (cart, tier, progressBar) {
    var min = Number(tier && tier.minimum);
    if (!min) return false;
    return qualifyingItemCount(cart, progressBar) >= min;
  };

window.pmTiersPctByItems = function (cart, bar, returnInt) {
  var count = qualifyingItemCount(cart, bar);

  var p1 = 33.3333;   // 3 items
  var p2 = 66.6667;   // 6 items
  var p3 = 100;       // 9 items

  // How much of each segment to use for micro-fill (0..1)
  // 0.5 means "only fill halfway toward the next tier inside the band"
  var MICRO = 0.5;

  var pct = 0;

  if (count >= 9) {
    pct = p3;
  } else if (count >= 6) {
    // Snap at 6
    pct = p2;

    // Micro-fill for 7–8 only
    if (count > 6) {
      var within = (count - 6) / 3; // 6->0, 9->1
      within = clamp(within, 0, 0.999);
      pct = p2 + (p3 - p2) * (within * MICRO);
    }
  } else if (count >= 3) {
    // Snap at 3
    pct = p1;

    // Micro-fill for 4–5 only
    if (count > 3) {
      var within1 = (count - 3) / 3; // 3->0, 6->1
      within1 = clamp(within1, 0, 0.999);
      pct = p1 + (p2 - p1) * (within1 * MICRO);
    }
  } else {
    // Micro-fill for 1–2 only (no snap before 3)
    if (count > 0) {
      var within0 = count / 3; // 0->0, 3->1
      within0 = clamp(within0, 0, 0.999);
      pct = (p1) * (within0 * MICRO);
    } else {
      pct = 0;
    }
  }

  if (returnInt) return clamp(Math.round(pct), 0, 100);
  return clamp(pct, 0, 100).toFixed(1) + "%";
};

  window.pmHasProgressPrompt = function (cart, bar) {
    var tiers = bar && Array.isArray(bar.tiers) ? bar.tiers : [];
    if (!tiers.length) return false;

    var count = qualifyingItemCount(cart, bar);

    var maxMin = 0;
    for (var i = 0; i < tiers.length; i++) {
      maxMin = Math.max(maxMin, Number(tiers[i].minimum || 0));
    }

    return count < maxMin || cartSubtotalCents(cart) < FREE_SHIP_THRESHOLD_CENTS;
  };

  // Prompt text below the bar (no $15+ disclaimer line)
  window.pmTierFeedbackText = function (cart, bar) {
    var tiers = sortedTiers(bar);
    if (!tiers.length) return "";

    var count = qualifyingItemCount(cart, bar);
    var subtotal = cartSubtotalCents(cart);

    // Find next tier
    var nextTier = null;
    for (var i = 0; i < tiers.length; i++) {
      var min = Number(tiers[i].minimum || 0);
      if (count < min) {
        nextTier = tiers[i];
        break;
      }
    }

    // Free shipping line
    var shipRemainingCents = Math.max(0, FREE_SHIP_THRESHOLD_CENTS - subtotal);
    var shipLine = shipRemainingCents > 0
      ? "<div>Add <strong>$" + (shipRemainingCents / 100).toFixed(2) + "</strong> more for <strong>free shipping</strong>.</div>"
      : "<div><strong>Free shipping unlocked</strong>.</div>";

    if (nextTier) {
      var nextMin = Number(nextTier.minimum || 0);
      var remainingItems = nextMin - count;
      var itemWord = remainingItems === 1 ? "item" : "items";
      var rewardLabel = window.pmTierRewardCopy(nextMin);

      return (
        "<div>Add <strong>" + remainingItems + "</strong> more qualifying " + itemWord +
        " to unlock <strong>" + rewardLabel + "</strong>.</div>" +
        shipLine
      );
    }

    return (
      "<div><strong>20% off (9+ items) unlocked</strong>.</div>" +
      shipLine
    );
  };

  // Debug toggle from console: pmRebuyBundleDebug(true)
  window.pmRebuyBundleDebug = function (on) {
    DEBUG = !!on;
    return DEBUG;
  };
})();
